/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import TagModel from 'cio/models/tag';
import CampaignModel from 'cio/models/campaign';

interface ApiTriggeredBroadcastsTableArgs {
  campaigns: CampaignModel[];
  onTagClicked: (tag: TagModel) => unknown;
  afterArchiveCampaignAction: (campaign: CampaignModel) => unknown;
  afterDeleteCampaignAction: (campaign: CampaignModel) => unknown;
  afterUnarchiveCampaignAction: (campaign: CampaignModel) => unknown;
}

export default class ApiTriggeredBroadcastsTable extends Component<ApiTriggeredBroadcastsTableArgs> {
  metricsTask = task(
    {
      enqueue: true,
      maxConcurrency: 4,
    },
    async (task: any) => {
      await task.perform();
    },
  );
}
